<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  currentlyWorking: boolean | null;
  classes?: string;
  size?: 'sm' | 'md' | 'lg';
}
const props = withDefaults(defineProps<Props>(), { size: 'md', classes: '' });
const { t } = useI18n();

// shared non‐size, non‐colour classes
const baseClasses = 'font-semibold border-2 rounded-lg whitespace-nowrap w-fit h-fit';

// only switch the colour palette
const statusClasses = computed(() =>
  props.currentlyWorking ? 'text-green-800 bg-green-200 border-green-300' : 'text-red-800 bg-red-200 border-red-300',
);

// only switch the padding & text-size
const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'px-1 py-0.5 text-xs';
    case 'lg':
      return 'px-4 py-2 text-sm';
    default:
      return 'px-2 py-1 text-xs'; // md
  }
});
</script>

<template>
  <div :class="[baseClasses, sizeClasses, statusClasses, props.classes]">
    {{ t(props.currentlyWorking ? 'employee.timeclock.currentlyWorking' : 'employee.timeclock.notCurrentlyWorking') }}
  </div>
</template>
